import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import Toolbar from './Toolbar';
export function PrimaryToolbarComponent(_ref) {
  var _api$analytics;
  var api = _ref.api,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    toolbarSize = _ref.toolbarSize,
    editorView = _ref.editorView,
    disabled = _ref.disabled,
    isReducedSpacing = _ref.isReducedSpacing,
    shouldUseResponsiveToolbar = _ref.shouldUseResponsiveToolbar;
  var _useSharedPluginState = useSharedPluginState(api, ['textFormatting']),
    textFormattingState = _useSharedPluginState.textFormattingState;
  return /*#__PURE__*/React.createElement(Toolbar, {
    textFormattingState: textFormattingState,
    popupsMountPoint: popupsMountPoint,
    popupsScrollableElement: popupsScrollableElement,
    toolbarSize: toolbarSize,
    isReducedSpacing: isReducedSpacing,
    editorView: editorView,
    isToolbarDisabled: disabled,
    shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
    editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
    api: api
  });
}